import { Navigate } from "react-router-dom";
import { useAdminAuth } from "../context/AdminAuthContext";

const AdminRoute = ({ children }) => {
  const { admin, loading } = useAdminAuth();

  if (loading && localStorage.getItem("admin_token")) return children;
  if (loading) return <div className="min-h-screen bg-[var(--bg-primary)]" />;

  if (!admin) return <Navigate to="/admin/login" />;

  return children;
};

export default AdminRoute;
